import { useCallback } from "react";
import { useShorthands } from "../context/ShorthandContext";

/**
 * Returns an `expand(text)` function that replaces the last word in `text`
 * if it matches a shorthand trigger. Returns the expanded string or the
 * original if no match.
 *
 * Also returns `onKeyDown(e, value, setValue)` — attach to any input to get
 * live expansion on Space or Tab.
 */
export function useShorthandExpansion() {
  const ctx = useShorthands();
  const entries = ctx?.entries || [];

  const expand = useCallback((text) => {
    if (!entries?.length) return text;
    const parts = text.split(/(\s+)/);
    const lastWord = parts[parts.length - 1];
    const match = entries.find(e => e.trigger === lastWord);
    if (!match) return text;
    parts[parts.length - 1] = match.expansion;
    return parts.join("");
  }, [entries]);

  const onKeyDown = useCallback((e, value, setValue) => {
    if (e.key !== " " && e.key !== "Tab") return;
    if (!entries?.length) return;
    const words = value.split(/\s+/);
    const last = words[words.length - 1];
    const match = entries.find(en => en.trigger === last);
    if (!match) return;
    e.preventDefault();
    words[words.length - 1] = match.expansion;
    setValue(words.join(" ") + " ");
  }, [entries]);

  return { expand, onKeyDown };
}
